// extracted by mini-css-extract-plugin
module.exports = {"FAQ_section":"FAQs_FAQ_section__2dyYh","addLink":"FAQs_addLink__22hpM","conversationText":"FAQs_conversationText__y4ADl","inputTextare":"FAQs_inputTextare__3XWvD"};